import { Injectable } from "@angular/core";

export interface ConvertResult {
  isValid: boolean;
  timeSalariesToAdd?: any [];
  timeSalariesToUpdate?: any[];
}

@Injectable({
  providedIn: 'root'
})
export class TimeSalaryToGridConverter {
  convert(timeSalaries: any[]) {
    for (let timeSalary of timeSalaries) {
      for (let timeType of timeSalary.TimesAggregatedByTimeType) {
        const identifier = `TimeType_${timeType.TimeTypeId}`;
        timeSalary[identifier] = timeType.SecondsToHHmmWithoutLabels;
      }
    }
  }
}
